var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('FontAwesomeIcon',{staticClass:"icon",attrs:{"icon":_vm.icon,"title":_vm.readableType}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }